import { createElement } from 'react';
import FormItem from './form-item';
const wrapper = function wrapper(NextFormComponent, displayName) {
    const WrappedComponent = (props = {}) => {
        const { formItemProps = {}, ...componentProps } = props;
        return createElement(FormItem, formItemProps, createElement(NextFormComponent, componentProps));
    };
    WrappedComponent.displayName = displayName;
    return WrappedComponent;
};
export default wrapper;
